import { PERMISSIONS } from '../../constants'
import list from './ProfileList'
import create from './ProfileCreate'
import edit from './ProfileEdit'
import ComponentWithPermissions from '../ComponentWithPermissions'

export default {
  edit: new ComponentWithPermissions({ component: edit, permissions: [PERMISSIONS.UPDATE_PROFILE] }),
  list,
  create: new ComponentWithPermissions({ component: create, permissions: [PERMISSIONS.CREATE_PROFILE] }),
  name: 'profiles',
  permissions: [PERMISSIONS.CREATE_PROFILE],
  options: { label: 'Perfis' }
}
